import React from 'react'
import { useLocation } from 'react-router-dom'
import { nameFor } from './countries'
import {
  readDraft,
  readSignupCommunityLogoDataUrl,
} from './signupState'

/**
 * Quiet identity context for the setup wizard: logo (or initial),
 * community name, and country. Renders nothing without a community name.
 */
export default function WizardIdentityStrip() {
  // Re-render when the wizard step (or re-entry from /signup/community) changes
  // so name / country / logo reflect the latest draft and localStorage.
  useLocation()

  const draft = readDraft()
  const communityName = (draft.organizationName || '').trim()
  if (!communityName) return null

  const countryCode = (draft.country || '').trim()
  const countryLabel = countryCode ? nameFor(countryCode) : ''
  const logoDataUrl = readSignupCommunityLogoDataUrl()
  const initial = communityName.charAt(0).toUpperCase() || '?'

  return (
    <div role="presentation" className="mb-6 flex w-full min-w-0 justify-center">
      <div className="inline-flex max-w-full min-w-0 items-center gap-3">
        {logoDataUrl ? (
          <div className="relative h-8 w-8 shrink-0 overflow-hidden rounded-md bg-[var(--signup-bg-subtle)]">
            <img
              src={logoDataUrl}
              alt=""
              className="h-full w-full object-cover"
            />
          </div>
        ) : (
          <div
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--signup-accent)] text-[14px] font-semibold leading-none text-white"
            aria-hidden
          >
            {initial}
          </div>
        )}
        <p className="min-w-0 truncate text-[14px] leading-snug text-[var(--signup-text-secondary)]">
          <span className="font-medium text-[var(--signup-text-secondary)]">
            {communityName}
          </span>
          {countryLabel ? (
            <>
              <span className="text-[var(--signup-text-tertiary)]"> · </span>
              <span className="font-medium text-[var(--signup-text-secondary)]">
                {countryLabel}
              </span>
            </>
          ) : null}
        </p>
      </div>
    </div>
  )
}
